import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%',
    },

    error: {
      border: `1px solid ${palette.error.main}`,
    },

    header: {
      padding: 12,

      '& .MuiTypography-root': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: 12,

        '& svg': {
          width: 14,
          height: 14,
        },
      },
    },

    content: {
      flex: 1,
      padding: 12,

      '& .MuiOutlinedInput-inputMultiline': {
        minHeight: 160,
      },
    },

    footer: {
      padding: '8px 12px',
    },

    buttonTest: {
      color: palette.blue,
    },

    switchChecked: {
      '&.Mui-checked': {
        color: palette.green,

        '& + .MuiSwitch-track': {
          backgroundColor: palette.green,
        },
      },
    },
    switchLabel: {
      fontSize: 12,
    },
    contentFields: {
      flexWrap: 'nowrap',
    },
  });
